// useEntityDetailsDialog — separat fil för hook-exporten så
// EntityDetailsContext.tsx (där provider:n bor) bara exporterar React-
// komponenter (annars klagar Fast Refresh).

import { useContext } from 'react';
import { EntityDetailsContext } from './EntityDetailsContext';
import type { EntityDetailsContextValue } from './EntityDetailsContext';

export function useEntityDetailsDialog(): EntityDetailsContextValue {
  const ctx = useContext(EntityDetailsContext);
  if (!ctx) {
    throw new Error('useEntityDetailsDialog must be used within EntityDetailsProvider');
  }
  return ctx;
}
